module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-195.86b9e0ed.svg";